<div class="drop-area">
  <wchfs-icon cdkDragHandle class="pointer" svgIcon="pso:input-file-no-bg_xl" size="45"></wchfs-icon>
  {{ title || 'Przeciągnij tutaj' }}
</div>
